export const DASHBOARD_TOOLTIP_TEXT = {
  // Toolbar buttons
  addPanel: 'Add panel',
  addGroup: 'Add panel group',
  downloadDashboard: 'Download JSON',
  editJson: 'Edit JSON',
  editVariables: 'Edit variables',
  editEvents: 'Edit events',
  settings: 'Settings',
  // Group buttons
  addPanelToGroup: 'Add panel to group',
  deleteGroup: 'Delete group',
  editGroup: 'Edit group',
  duplicateGroup: 'Duplicate group',
  moveGroupDown: 'Move group down',
  moveGroupUp: 'Move group up',
  cleanUpLayout: 'Clean up layout',
  // Panel buttons
  editPanel: 'Edit',
  duplicatePanel: 'Duplicate',
  deletePanel: 'Delete',
  movePanel: 'Move',
  editDynamicPanel: 'Edit main panel',
  // Variable editor buttons
  refreshVariableValues: 'Refresh values',
  copyVariableValues: 'Copy values to clipboard',
};

export const ARIA_LABEL_TEXT = {
  // Group buttons
  addPanelToGroup: (groupName: string) => `add panel to group ${groupName}`,
  deleteGroup: (groupName: string) => `delete group ${groupName}`,
  editGroup: (groupName: string) => `edit group ${groupName}`,
  duplicateGroup: (groupName: string) => `duplicate group ${groupName}`,
  moveGroupDown: (groupName: string) => `move group ${groupName} down`,
  moveGroupUp: (groupName: string) => `move group ${groupName} up`,
  cleanUpLayout: (groupName: string) => `clean up layout for group ${groupName}`,
  // Panel buttons
  editPanel: (panelName: string) => `edit panel ${panelName}`,
  duplicatePanel: (panelName: string) => `duplicate panel ${panelName}`,
  deletePanel: (panelName: string) => `delete panel ${panelName}`,
  movePanel: (panelName: string) => `move panel ${panelName}`,
};
